export const CLOUD_NAME = 'jandcomic';
export const COMIC_PRESET = 'jandComic';
export const CHARACTER_PRESET = 'jandCharacter';
